import axios from 'axios';
import format from 'date-fns/format';

import {
  FETCH_PAYMENTS,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_ERROR,
  API_DATE_FORMAT,
} from './constants';

const formatDate = (date) => format(date, API_DATE_FORMAT);

export function fetchPaymentsStart() {
  return {
    type: FETCH_PAYMENTS,
  };
}

export function fetchPaymentsSuccess(data) {
  return {
    type: FETCH_PAYMENTS_SUCCESS,
    data,
  };
}

export function fetchPaymentsError(error) {
  return {
    type: FETCH_PAYMENTS_ERROR,
    error,
  };
}

export function fetchPayments() {
  return (dispatch, getState) => {
    dispatch(fetchPaymentsStart());

    const { detalizationNew: { periodSelection } } = getState();

    axios.get('/api/profile/detalization/paymentsPrepaid', {
      params: {
        periodStart: formatDate(periodSelection.startPeriod),
        periodEnd: formatDate(periodSelection.endPeriod),
      },
    })
      .then((response) => dispatch(fetchPaymentsSuccess(response.data)))
      .catch((error) => dispatch(fetchPaymentsError(error.response)));
  };
}
